
import { useState, useEffect, useContext, createContext } from "react";


import { fetchPlatform } from "../utilities/server-fetch";


export {
  PlatformContextProvider,
  usePlatform, usePlatformUpdate
};


const PlatformContext = createContext<any>( null ); // TODO: Properly fill out

const PlatformUpdateContext = createContext<any>( null ); // TODO: Properly fill out


function usePlatform() {
  return useContext( PlatformContext );
}

function usePlatformUpdate() {
  return useContext( PlatformUpdateContext );
}




function PlatformContextProvider( {children}: ComponentProps ) {
  // Provider handles...

  // ... Creating State
  const [ platform, setPlatform ] = useState( null );


  useEffect( () => {

    const updateData = async () => {
      const platform = await fetchPlatform( "pivotalWisdom" );

      setPlatform( platform );
    };

    updateData();
  }, [] );




  // ... Updating State




  // ... Persisting State down into Children
  return (
    <PlatformContext.Provider value={ {platform} } >
      <PlatformUpdateContext.Provider value={ {} } >
        {children}
      </PlatformUpdateContext.Provider>
    </PlatformContext.Provider>
  )
}















/* */
